export const Consent_DA = {
  cookies: {
    headline: "Cookies",
    description:
      "Vi bruger cookies for at give dig den bedst mulige oplevelse på vores hjemmeside.",
    more: "Du kan læse mere om, hvilke cookies vi bruger i vores",
    link: "Privatlivspolitik",
    essential:
      "Funktionelle cookies: Disse cookies er nødvendige for, at vores websted fungerer efter hensigten.",
    optional:
      "Valgrie cookies: Vi forbeholder os retten til at bruge disse cookies for at få en bedre forståelse af vores brugere og hvordan de bruger vores hjemmeside.",
    button: {
      accept: "Accepter alle cookies",
      decline: "Afvis valgfrie cookies",
    },
  },
};
